import { css, cx } from 'linaria';
import { buttonReset } from 'components/buttons/button-reset';
import { tagBase } from './tags';
const bestOfTag = "b1y8e1q1";
export const BestOfTag = ({
  children
}) => <div className={cx(buttonReset, tagBase, bestOfTag)}>{children}</div>;

require("./tag-best-of.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag-best-of.js");